function isWomensUnderwear(productGroup) {
  let isWomensUnderwear = false;
  if (productGroup) {
    isWomensUnderwear =
      productGroup.slug.current === "lounge-bra" ||
      productGroup.slug.current === "bikini" ||
      productGroup.slug.current === "thong";
  }
  return isWomensUnderwear;
}

function isSocks(productGroup) {
  let isSocks = false;
  if (productGroup) {
    isSocks =
      productGroup.slug.current === "crew-socks" || productGroup.slug.current === "rib-socks";
  }
  return isSocks;
}

function getMediaListFromProduct(productGroup, currentProduct, getSecondImage = false) {
  const shopifyProduct = productGroup.shopifyProducts.find(
    (shopifyProduct) =>
      shopifyProduct.productReferenceV2.id === currentProduct.productReferenceV2.id
  );

  if (shopifyProduct) {
    let flatShotIndex = shopifyProduct.media.edges.length - 1;
    let firstImageIndex = 0;
    if (isWomensUnderwear(productGroup)) {
      flatShotIndex = shopifyProduct.media.edges.length - 2;
    } else if (isSocks(productGroup)) {
      flatShotIndex = 0;
      firstImageIndex = 1;
    }
    return [
      {
        flatShot: shopifyProduct.media.edges.map((media) => media.node)[flatShotIndex],
        firstImage: getSecondImage
          ? shopifyProduct.media.edges.map((media) => media.node)[firstImageIndex]
          : {},
        productGroup: productGroup,
      },
    ];
  }

  return [];
}

export function resolveImages(productGroups, section, state) {
  let mediaList = [];
  mediaList = productGroups.map((pg) => {
    if (state[`${section.key}-productGroup`]._id === pg._id && state[`${section.key}-product`]) {
      return getMediaListFromProduct(
        pg,
        state[`${section.key}-product`],
        productGroups.length === 1
      );
    }
    return getMediaListFromProduct(pg, pg.shopifyProducts[0], productGroups.length === 1);
  });

  return mediaList.flat();
}
